// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const CrossHairOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M14.5 11.02H22v2h-7.5v-2zM11 14.5V22h2v-7.5h-2zM11 11h2v2h-2v-2zM2 11.02h7.5v2H2v-2zM11 2v7.5h2V2h-2z","fill":"currentColor"}}]},"name":"cross-hair","theme":"outlined"};

const CrossHairOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={CrossHairOutlinedSvg} />;
  CrossHairOutlined.displayName = 'CrossHairOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(CrossHairOutlined);
